import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    title: 'Tratar de "caerles mejor"',
    desc: 'a los tóxicos solo les dio más poder para manipularte.'
  }, {
    title: 'Quejarte en el grupo de WhatsApp',
    desc: 'solo mantuvo tu sistema nervioso en alerta roja.'
  }, {
    title: 'Leer libros de motivación genérica',
    desc: 'te hizo sentir culpable por "no tener la actitud correcta".'
  }, {
    title: 'Esperar que la empresa cambie',
    desc: 'es una trampa que te mantiene estancado y frustrado.'
  }];
  return <section className="bg-light-bg text-text-light py-20 md:py-28" data-id="element-14">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-primary-dark" data-id="element-17">
            Por qué lo que intentaste hasta ahora no funcionó
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8" data-id="element-18">
          {approaches.map((item, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-19">
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4 h-full transition-transform hover:-translate-y-1 duration-300" data-id="element-20">
                <div className="mt-1 bg-red-100 p-2 rounded-full text-red-500 shrink-0" data-id="element-21">
                  <X size={20} strokeWidth={3} data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h3 className="font-bold text-lg mb-2 text-primary-dark" data-id="element-24">
                    {item.title}
                  </h3>
                  <p className="text-text-muted leading-relaxed" data-id="element-25">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}